// Chiama una funzione "func" dopo "timeout" ms se debounce non viene chiamato prima, in quel caso riparte il timer 
function debounce(func, timeout = 1000){
  let timer;
  
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => { func.apply(this, args); }, timeout);
  };
}

/**
 * handles separators per line to only have them between elements
 */
class MenuSeparators {
  constructor(element, spacing=1, separator='|') {
    this.element = element
    this.prev_top_dist = Math.round(jQuery(this.element).offset().top)

    jQuery(this.element).css({
      marginLeft: spacing + 'em',
      position: 'relative',
    })
    jQuery(this.element).parent().css({
      marginLeft: -spacing/2 + 'em'
    })
    
    jQuery(this.element).each((index, el)=>{
      // skip first
      if (index==0) return

      let separator_html = jQuery(`<span class="separator">${separator}</span>`).css({
        position: 'absolute',
        top: 0,
        left: (-spacing / 2) + 'em',
        translate: '-50%'
      })
      
      jQuery(el).append(separator_html)
    })

    this.handleMenuSeparators()
    jQuery(window).on('resize', ()=>this.handleMenuSeparators())
  }

  handleMenuSeparators() {
    jQuery(this.element).each((index, el)=>{
      let top_dist = Math.round(jQuery(el).offset().top)
      
      // skip first
      if (index==0) {
        this.prev_top_dist = top_dist
      }

      if (top_dist != this.prev_top_dist) {
        jQuery(el).children('.separator').css({display: 'none'})
        this.prev_top_dist = top_dist
      } else {
        jQuery(el).children('.separator').css({display: 'unset'})
      }
    })
  }
}